
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/services/migration-and-upgrade",
      function () {
        return require("private-next-pages/services/migration-and-upgrade.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/services/migration-and-upgrade"])
      });
    }
  